import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "@/core/store/useAppStore";
import { AdminMediaCard } from "@/components/MediaCard";
import { VideoPlayer } from "@/components/ui/VideoPlayer";
import { MediaItem } from "@/core/MediaItem/MediaItem.model";
import { MediaStage } from "@/core/types/mediaTypes";
import { LibraryLayout, ContentType } from "./LibraryLayout";

export const PostVideoLibrary: React.FC = () => {
  const { selectedClient } = useAppStore();
  const navigate = useNavigate();
  const [selectedVideo, setSelectedVideo] = useState<MediaItem | null>(null);
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);

  const handleContentTypeChange = (contentType: ContentType) => {
    const pathMap: Record<ContentType, string> = {
      images: "../photos",
      "post-videos": "../post-videos",
      stories: "../stories",
      reels: "../reels",
      videos: "../videos",
      audio: "../audio",
      assets: "../assets",
    };
    navigate(pathMap[contentType]);
  };

  const handleVideoClick = (video: MediaItem) => {
    setSelectedVideo(video);
    setIsPlayerOpen(true);
  };

  const handlePlayerClose = () => {
    setIsPlayerOpen(false);
    setSelectedVideo(null);
  };

  const renderGrid = (
    items: MediaItem[],
    handleStageChange: (updatedItem: MediaItem, oldStage: MediaStage) => void,
    _handleItemClick?: (item: MediaItem) => void,
    selectionMode?: {
      isActive: boolean;
      selectedIds: number[];
      onToggle: (id: number, event: React.MouseEvent) => void;
    },
    onAddToCollection?: (mediaItemId: number) => void,
  ) => (
    <>
      {items.map((mediaItem) => (
        <AdminMediaCard
          key={mediaItem.id}
          mediaItem={mediaItem}
          clientId={selectedClient?.id || ""}
          aspectRatio="4:5"
          onClick={() => handleVideoClick(mediaItem)}
          onStageChange={handleStageChange}
          onMediaItemDeleted={() => {}}
          selectionMode={selectionMode}
          onAddToCollection={onAddToCollection}
        />
      ))}
    </>
  );

  return (
    <LibraryLayout
      contentTypes={["post_video"]}
      activeContentType="post-videos"
      onContentTypeChange={handleContentTypeChange}
      renderGrid={renderGrid}
      extraContent={
        selectedVideo ? (
          <VideoPlayer
            mediaItem={selectedVideo}
            isOpen={isPlayerOpen}
            onClose={handlePlayerClose}
            clientId={selectedClient?.id}
          />
        ) : null
      }
    />
  );
};
